import { render, staticRenderFns } from "./TopModelBar.vue?vue&type=template&id=519fe8d3"
import script from "./TopModelBar.vue?vue&type=script&lang=js"
export * from "./TopModelBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports